import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="tabs"
//
// Lightweight tab switcher. Each tab button carries `data-tab="<name>"`
// and each panel carries a matching `data-tab="<name>"`. Clicking a tab
// marks it active and shows only the panel with the same name.
export default class extends Controller {
  static targets = ["tab", "panel"]

  select(event) {
    const name = event.currentTarget.dataset.tab
    this.tabTargets.forEach((tab) => {
      tab.classList.toggle("on", tab.dataset.tab === name)
    })
    this.panelTargets.forEach((panel) => {
      panel.style.display = panel.dataset.tab === name ? "" : "none"
    })
  }
}
